import React, { useState } from "react";
import { motion } from "framer-motion";
import artist_band from "src/assets/img/banner.jpg";
import { themeStyle } from "src/themes";
import { useTranslation } from "react-i18next";

function ArtistModal({ isOpen, onClose }) {
  const { t } = useTranslation();
  const handleSubmit = (e) => {
    const mailtoUrl = `mailto:support@flirttool.com?subject=Support Request&body=${encodeURIComponent()}`;
    window.location.href = mailtoUrl;
  };

  return (
    <motion.div
      initial={{ x: "100%" }}
      animate={{ x: isOpen ? "0%" : "100%" }}
      transition={{ type: "spring", stiffness: 300, damping: 30 }}
      className="fixed z-40 top-16 bg-white right-10  w-[clamp(280px,89%,500px)] min-[680px]:w-[clamp(280px,70%,720px)] sm:h-[clamp(300px,70vh,500px)] phone:h-[200px] flex flex-col items-center rounded-md overflow-hidden"
    >
    
      <img
        src={artist_band}
        alt=""
        className="absolute inset-0 w-full phone:h-auto sm:h-full bg-cover"
      />

      <button
        style={{ backgroundColor: "#FF3131" }}
        onClick={handleSubmit}
        className="text-white absolute bottom-0  hover:opacity-75 focus:outline-none  font-medium text-xs sm:text-sm w-fit w-full px-5 py-2 text-center"
      >
       {t("Apply Now")}
      </button>
    </motion.div>
  );
}

export default ArtistModal;
